import Presenter from './Presenter';

const StatsContainer = () => {
    return <Presenter />;
};

export default StatsContainer;
